export const formatMd = (textWithMd, textWithoutMd, isMd = false) => (isMd ? textWithMd : textWithoutMd);

export default formatMd;
